import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "X-API-Key": process.env.REACT_APP_API_KEY },
});

// Authenticated file download (blob) — for endpoints returning xlsx/zip
export const downloadFile = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

// Helpers
export const todayISO = () => new Date().toISOString().slice(0, 10);

// Display formatter: ISO (YYYY-MM-DD) -> DD-MM-YY
export const fmtDate = (iso) => {
  if (!iso || typeof iso !== "string") return "";
  const parts = iso.slice(0, 10).split("-");
  if (parts.length !== 3) return iso;
  const [y, m, d] = parts;
  return `${d}-${m}-${y.slice(2)}`;
};

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(Number(n || 0)));

export const fmtNum = (n, d = 2) =>
  Number(n || 0).toLocaleString("en-IN", {
    maximumFractionDigits: d,
    minimumFractionDigits: 0,
  });

export const seed = async () => {
  try {
    await api.post("/seed");
  } catch (e) {
    // ignore
  }
};

// Unit-aware helpers
export const unitLabel = (unit) => (unit === "piece" ? "pc" : "kg");
export const unitLabelPlural = (unit) => (unit === "piece" ? "pcs" : "kg");
export const fmtQty = (n, unit) =>
  unit === "piece"
    ? `${Math.round(Number(n || 0))} ${unitLabelPlural(unit)}`
    : `${fmtNum(n, 3)} kg`;
